// Progreso efímero del recorrido activo Partida → Faro → Acuerdos.
// No guarda identidad ni persiste decisiones o ubicación del jugador.

import { ISLAS_CAPITULO_1 } from "./mundo";

export type IslaEP01 = "isla-partida" | "isla-faro" | "isla-acuerdos";
export type ObjetivoRutaEP01 = "faro" | "acuerdos" | "punto-encuentro" | "llegada";

export interface ProgresoRutaEP01 {
  /** Última isla alcanzada; se conserva mientras se cruza un puente. */
  readonly islaActual: IslaEP01;
  readonly faroVisitado: boolean;
}

export const PROGRESO_RUTA_EP01_INICIAL: ProgresoRutaEP01 = {
  islaActual: "isla-partida",
  faroVisitado: false,
};

const CLAVES_DE_RUTA = new Set<IslaEP01>(["isla-partida", "isla-faro", "isla-acuerdos"]);

/** Devuelve la isla jugable bajo el personaje, no la mera cercanía al CTA. */
export function islaEP01BajoPies(x: number, z: number): IslaEP01 | null {
  let mejor: { readonly clave: IslaEP01; readonly distancia: number } | null = null;

  for (const isla of ISLAS_CAPITULO_1) {
    if (!CLAVES_DE_RUTA.has(isla.clave as IslaEP01)) continue;
    const distancia = Math.hypot(x - isla.centro[0], z - isla.centro[1]);
    if (distancia > isla.radioCaminable) continue;
    if (!mejor || distancia < mejor.distancia) {
      mejor = { clave: isla.clave as IslaEP01, distancia };
    }
  }

  return mejor?.clave ?? null;
}

/** Marca hitos alcanzados; null significa que el jugador está entre islas. */
export function registrarIslaEP01(
  progreso: ProgresoRutaEP01,
  isla: IslaEP01 | null,
): ProgresoRutaEP01 {
  if (isla === null) return progreso;
  if (
    progreso.islaActual === isla &&
    (isla !== "isla-faro" || progreso.faroVisitado)
  ) {
    return progreso;
  }

  return {
    islaActual: isla,
    faroVisitado: progreso.faroVisitado || isla === "isla-faro",
  };
}

/** Objetivo contextual sin convertir el paseo en una secuencia obligatoria. */
export function objetivoActualEP01(
  progreso: ProgresoRutaEP01,
  enPuntoDeEncuentro: boolean,
): ObjetivoRutaEP01 {
  if (enPuntoDeEncuentro) return "llegada";
  if (progreso.islaActual === "isla-acuerdos") return "punto-encuentro";
  if (progreso.islaActual === "isla-faro") return "acuerdos";
  return "faro";
}
